// extracted by mini-css-extract-plugin
export default {"container":"style_container__Bq6D3"};